module.exports = __webpack_public_path__ + "static/media/popoverCreated.9aee2341.png";